var CIDSerialiser = require('conversation/conversation-id-serialiser');
var Codec = require('io/codec');

module.exports = {
    read : function(input) {
        var cid = CIDSerialiser.read(input);
        var path = Codec.readString(input);

        return { cid : cid, path : path };
    },
    write : function(output, req) {
        CIDSerialiser.write(output, req.cid);
        Codec.writeString(output, req.path);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-registration-request-serialiser.js
// module id = 1083
// module chunks = 1